import { RootState } from '../store/configureStore';

export const getSummary = (state: RootState) => state?.summary?.summary;

export const isFetchingSummary = (state: RootState) =>
  state?.summary?.isFetchingSummary;

export const didFetchingSummaryFailed = (state: RootState) =>
  state?.summary?.fetchingSummaryFailed;
